import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [org, setOrg] = useState(null);
  const [clients, setClients] = useState([]);
  const [activeClientId, setActiveClientId] = useState(localStorage.getItem("celebre_client") || "");
  const [loading, setLoading] = useState(true);

  const refreshOrg = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setOrg(data.org);
      return data;
    } catch {
      setUser(null);
      setOrg(null);
      return null;
    }
  }, []);

  const loadClients = useCallback(async () => {
    try {
      const { data } = await api.get("/clients");
      setClients(data);
      setActiveClientId((prev) => (data.find((c) => c.client_id === prev) ? prev : data[0]?.client_id || ""));
      return data;
    } catch { return []; }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    (async () => {
      const me = await refreshOrg();
      if (me) await loadClients();
      setLoading(false);
    })();
  }, [refreshOrg, loadClients]);

  useEffect(() => {
    if (activeClientId) localStorage.setItem("celebre_client", activeClientId);
  }, [activeClientId]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("celebre_token");
    setUser(null);
    setOrg(null);
    window.location.href = "/";
  };

  const activeClient = clients.find((c) => c.client_id === activeClientId) || null;

  return (
    <AppContext.Provider value={{ user, setUser, org, setOrg, refreshOrg, clients, loadClients, activeClientId, setActiveClientId, activeClient, loading, logout }}>
      {children}
    </AppContext.Provider>
  );
}
